<template>
  <div class="mockExamination secondary_page_bg">
    <!-- <bannerof
      style="color: #ffffff"
      :Imgsrc="bannerData.imgUrl"
      :title="bannerData.title"
      :subtitle="bannerData.subtit"
    ></bannerof> -->
    <secondary-banner title="考核习题库" :img="require('@/assets/images/usertype/bnner.png')"></secondary-banner>
    <div class="inner mockInner">
      <div class="mockcenter">
        <div class="mocktypelist">
          <div class="mocktype_list">
            <span
              class="eltyspan"
              :class="queryParams.repoType == null ? 'selstyle' : ''"
              @click="selbtns(0)"
              >全部</span
            >
            <span
              v-for="(item, index) in careeTypeList"
              :key="index"
              @click="selbtns(item)"
              class="eltyspan"
              :class="queryParams.repoType == item.dictValue ? 'selstyle' : ''"
              >{{ item.dictLabel }}</span
            >
          </div>
        </div>
        <!-- 考试列表 -->
        <div v-if="examList == null">
          <el-empty description="加载中"></el-empty>
        </div>
        <div v-else-if="examList.length == 0">
          <el-empty description="空空如也"></el-empty>
        </div>
        <div class="mock_examlist" v-else>
          <examlistItem :examList="examList"></examlistItem>
        </div>
        <div class="page_pl">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.pageNum"
            :page-size="queryParams.pageSize"
            background
            layout="total,prev, pager, next"
            :total="total"
            hide-on-single-page
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { systemList, mockexamList } from "@/api/mockExamination";
import bannerof from "@/components/bannerof";
import examlistItem from "@/components/examlist/index.vue";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  name: "mockExamination",
  data() {
    return {
      bannerData: {
        title: "",
        subtit: "",
        imgUrl: require("@/assets/images/mockbanner.png"),
      },
      queryParams: {
        repoType: null,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      careeTypeList: [],
      examList: null,
    };
  },
  components: {
    bannerof,
    examlistItem,
    SecondaryBanner,
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 1090);
    this.tikTypes();
    this.mocklistall();
  },
  mounted() {},
  methods: {
    //题库类型
    tikTypes() {
      let params = {
        dictType: "business_repo_type",
      };
      systemList(params).then((res) => {
        this.careeTypeList = res.rows;
      });
    },
    //筛选
    selbtns(item) {
      if (item == 0) {
        this.queryParams.repoType = null;
      } else {
        this.queryParams.repoType = item.dictValue;
      }
      this.mocklistall();
    },
    //考试列表
    mocklistall() {
      mockexamList(this.queryParams).then((res) => {
        // 该用户考试过的不展示
        this.examList = res.rows;
        this.total = res.total;
      });
    },
    //分页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.mocklistall();
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.mockExamination {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 100px;
  overflow: hidden;
  .mockInner {
    margin-top: 72px;
    border-radius: 8px;
    background-color: #ffffff;
    overflow: hidden;
  }
  .mockcenter {
    .mocktypelist {
      padding: 20px 0;
      border-bottom: 1px solid #efefef;
      overflow: hidden;

      .selstyle {
        border: 1px solid #1d4434 !important;
        color: #ffffff !important;
        background: #1d4434;
      }
      .mocktype_list {
        float: left;
        .eltyspan {
          display: inline-block;
          padding: 7px 17px;
          margin: 5px 10px;
          border-radius: 20px;
          text-align: center;
          font-size: 18px;
          color: #333333;
          user-select: none;
          cursor: pointer;
          border: 1px solid #1d4434;
          font-weight: 400;
          white-space: nowrap;
        }
      }
    }
    // 分页
    .page_pl {
      margin: 30px 0;
      text-align: center;
    }
  }
}
</style>
